import { RadioGroup as HIRadioGroup } from '@headlessui/react'
import classNames from 'classnames'
import { useEffect, useState } from 'react'

export interface IRadioOption {
    label: string
    value: any
    description?: string
}
interface IRadioGroup {
    options: IRadioOption[]
    handleSelectOption: (option: any) => void
    className?: string
    buttonWidth?: string
    width?: string
    height?: string
    label?: string
    defaultSelectIndex?: number
}

export default function RadioGroup(props: IRadioGroup) {
    const [selected, setSelected] = useState<IRadioOption | null>(
        props.options[0] || null
    )

    useEffect(() => {
        if (props.defaultSelectIndex && props.defaultSelectIndex >= 0 && props.options.length > props.defaultSelectIndex) {
            setSelected(props.options[props.defaultSelectIndex])
        }
    }, [])

    function handleRadioChange(selectedOption: IRadioOption) {
        setSelected(selectedOption)
        props.handleSelectOption(selectedOption.toString())
    }
    return (
        <div className="w-full px-4 pb-10">
            <div className="mx-auto w-full max-w-md">
                <HIRadioGroup name="options" value={selected} onChange={handleRadioChange}>
                    <HIRadioGroup.Label>
                        <label
                            className={classNames(
                                `font-sans block mb-1.5 text-md font-medium text-gray-700 `
                            )}
                        >
                            {props.label}
                        </label>
                    </HIRadioGroup.Label>
                    <div className="flex flex-row space-x-5 justify-center">
                        {props.options.map(({ label, value, description }) => (
                            <HIRadioGroup.Option
                                key={value}
                                value={value}
                                className={({ active, checked }) =>
                                    `${active
                                        ? 'ring-2 ring-white ring-opacity-60 ring-offset-2 ring-offset-sky-300 '
                                        : ''
                                    }
                  ${checked
                                        ? 'bg-sky-900 bg-opacity-75 text-white'
                                        : 'bg-white'
                                    }
                    flex items-center justify-center cursor-pointer p-2 shadow-md focus:outline-none border-[1.5px] border-gray-400 hover:bg-gray-200
                    
                    ${props.buttonWidth ? props.buttonWidth : 'w-28'}
                    ${props.height ? props.height : "h-[2.75rem] pt-[0.75rem]"}
                    `
                                }
                            >
                                {({ active, checked }) => (
                                    <>
                                        <div className="flex items-center justify-center">
                                            <div className="md:text-sm text-xs">
                                                <HIRadioGroup.Label
                                                    as="p"
                                                    className={`font-medium ${checked
                                                        ? 'text-white'
                                                        : 'text-gray-900'
                                                        }`}
                                                >
                                                    {label}
                                                </HIRadioGroup.Label>
                                                {description && (
                                                    <HIRadioGroup.Description
                                                        as="span"
                                                        className={`inline ${checked
                                                            ? 'text-sky-100'
                                                            : 'text-gray-500'
                                                            }`}
                                                    >
                                                        <span>
                                                            {description}
                                                        </span>
                                                    </HIRadioGroup.Description>
                                                )}
                                            </div>
                                            {checked && (
                                                <div className="text-white">
                                                    <CheckIcon className="h-[1.1rem] w-[1.1rem] -mr-6 ml-1.5" />
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                            </HIRadioGroup.Option>
                        ))}
                    </div>
                </HIRadioGroup>
            </div>
        </div>
    )
}

function CheckIcon(props: any) {
    return (
        <svg viewBox="0 0 24 24" fill="none" {...props}>
            <circle cx={12} cy={12} r={12} fill="#fff" opacity="0.2" />
            <path
                d="M7 13l3 3 7-7"
                stroke="#fff"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
